import styled from "../theme";
import { PulseLoader } from "react-spinners";

export const LoadingAnimation = styled(PulseLoader)``;
LoadingAnimation.defaultProps = { color: "#F3F3F3" };
